
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CelebrationIcon from '@mui/icons-material/Celebration';
import AvTimerIcon from '@mui/icons-material/AvTimer';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import TtkList from './TtkList';

const CarRentalTTK = ({ data }) => {

    return (
        <>

            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <LocationCityIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Serving Cities :</b>&nbsp;<TtkList data={data?.areaOfWorking} /></p>
                        </div>

                        <div className='col-md-4'>
                            <p> <AvTimerIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Rental Duration :</b>&nbsp;<TtkList data={data?.duration} /></p>
                        </div>

                    </div>
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <p> <DriveEtaIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Drive Type :</b>&nbsp;<TtkList data={data?.driveType} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>price :</b>&nbsp;<span>{data?.price}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p><CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Purpose:</b>&nbsp;<TtkList data={data?.purpose} /></p>
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <div className=''>
                            <p> <DriveEtaIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Type of Vehicle :</b>&nbsp;<TtkList data={data?.vehicle} /></p>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default CarRentalTTK